import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const OrdersRoute = [
    {
        path: '/orders',
        component: React.lazy(() => import('./Orders.js')),
        auth: AuthRoles.editor,
    }
]

export default OrdersRoute;